import React from "react";
import { useTranslation } from "react-i18next";
import TopMenu from "../../components/TopMenu/TopMenu";
import "./PlantaoDigital.css";

export default function PlantaoDigital() {
  const { t } = useTranslation();
  
  return (
    <div className="plantao-digital-page">
      <TopMenu />

      <main className="plantao-digital-content">
        <div className="plantao-digital-cards">
          <div className="plantao-digital-card">
            <span className="plantao-digital-card-title">
              {t("pages.plantaoDigital.linkPlantao")}
            </span>
          </div>

          <div className="plantao-digital-card">
            <span className="plantao-digital-card-title">
              {t("pages.plantaoDigital.formularioPos")}
            </span>
          </div>
        </div>
      </main>
    </div>
  );
}

